// extracted by mini-css-extract-plugin
export default {"highlighted":"Advantage_highlighted__+8+uQ","smallHeading":"Advantage_smallHeading__dpAZe","advStatus":"Advantage_advStatus__Bs3-2","enrolled":"Advantage_enrolled__SPxHR"};